import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'
import { SeniorLeaderCount } from '../types/insights'

export function usePacketsBySeniorLeader(year?: string, limit?: number) {
  return useQuery({
    queryKey: ['insights', 'packets-by-senior-leader', year, limit],
    queryFn: async () => {
      const params: Record<string, string> = {}
      if (year) params.year = year
      if (limit) params.limit = limit?.toString() || ''
      const response = await get<{ data: SeniorLeaderCount[] }>('/insights/packets-by-senior-leader', params)
      return response.data
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 2, // 2 hours
  })
} 